import React from 'react'
import { Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { Button } from 'reactstrap'
import { message } from 'antd'

import { updateDocument } from '../services'
import { handleError } from '../../../helpers'

export default function DocumentContentWidget({ document }) {
	const { register, handleSubmit } = useForm({
		defaultValues: {
			title: document.title,
			keywords: document.keywords,
		}
	})

	const onSubmit = values => {
		updateDocument(document.id, values)
			.then(res => message.success(res.data.message))
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Form.Group>
					<Form.Label>Nombre del Documento</Form.Label>
					<Form.Control 
						{...register('title')}
						placeholder="Escriba aquí el nombre del documento"
					/>
				</Form.Group>
				<Form.Group>
					<Form.Control 
						as="textarea"
						{...register('keywords')}
						placeholder="Escriba aquí las palabras clave"
						style={{ height: '150px' }}
					/>
					<Form.Text className="text-muted">
						Las palabras clave se separan por comas.
					</Form.Text>
				</Form.Group>
				<Button outline color='primary' type='submit'>Actualizar Documento</Button>
			</Form>
		</React.Fragment>
	)
}